export const registrationClosesAt = new Date('2026-09-04T11:00:00.000Z')

export const isRegistrationClosed = (): boolean => new Date() >= registrationClosesAt